<template>
  <div id="moneyRain">
    <div v-for="item in moneyList" :key="item.id" :class="['money', item.type]" :style="item.style">
      <div class="sprite-animation"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue';

interface MoneyItem {
  id: number;
  type: string;
  style: Record<string, string>;
}

const moneyList = ref<MoneyItem[]>([]);
const moneyTypes = [''];
let idCounter = 0;
let spawnInterval: number;

function spawnMoney() {
  const type = moneyTypes[Math.floor(Math.random() * moneyTypes.length)];
  const left = Math.random() * 2000;
  const delay = 0;
  const duration = 2 + Math.random() * 10; // 6s to 10s
  const rotation = Math.random() > 0.5 ? 720 : -720;

  const item: MoneyItem = {
    id: idCounter++,
    type,
    style: {
      left: `${left}vw`,
      animationDelay: `${delay}s`,
      animationDuration: `${duration}s`,
      '--rotation': `${rotation}deg`,
    },
  };

  moneyList.value.push(item);

  // Remove item after animation finishes
  setTimeout(() => {
    moneyList.value = moneyList.value.filter(i => i.id !== item.id);
  }, duration * 1000);
}

onMounted(() => {
  spawnInterval = window.setInterval(() => {
    for (let i = 0; i < 15; i++) {
      spawnMoney();
    }
  }, 100); // Add 3 every 300ms
});

onBeforeUnmount(() => {
  clearInterval(spawnInterval);
});
</script>

<style scoped>
#moneyRain {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  pointer-events: none;
  z-index: 9999;
  overflow: hidden;
  backdrop-filter: blur(.26667rem);
  background: #000000a3;
}

.money {
  position: absolute;
  top: -100px;
  /* background-image: url('@/assets/theme/coins-ani.png'); */
  background-size: contain;
  background-repeat: no-repeat;
  animation-name: fallAndSpin;
  animation-timing-function: linear;
  animation-iteration-count: 1;
  will-change: transform;
}

.sprite-animation {
    width: 80px;
    height: 80px;
    background-image: url('@/assets/theme/coins-ani.png');
    animation-name: sprite;
    animation-duration: 0.5s;
    animation-timing-function: steps(5);
    animation-iteration-count: infinite;
}

@keyframes sprite {
    from {
        background-position: 0px;
    }

    to {
        background-position: -400px;
    }
}
@keyframes fallAndSpin {
  0% {
    transform: translateY(0px) rotate(0deg);
    opacity: 1;
  }

  100% {
    transform: translateY(110vh) rotate(var(--rotation, 720deg));
    opacity: 1;
  }
}
</style>
